var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FlexBox } from '@brg/ui';
import React, { useMemo } from 'react';
import { CourseHomeworkEditWrapper, CourseTitle, InputWrapper } from '../style';
import useLocalization from '../../../../../../hooks/useLocalization';
import { Input as StyledInput, InputGroupWrapper } from '../../../editor/MediaInputGroup/styles';
import { Input } from '@brg/input';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getLMSGroups } from '../../../../../../reducers/getLMSInfo';
import { API } from '@brg/api';
var HeaderInput = styled(StyledInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   font-size: 15px;\n   line-height: 20px;\n"], ["\n   font-size: 15px;\n   line-height: 20px;\n"])));
export var HeaderBlock = function (props) {
    var _a = useLocalization(), t = _a.t, language = _a.language;
    var text = props.text, onHeaderChange = props.onHeaderChange, type = props.type, nominationType = props.nominationType, onSystemType = props.onSystemType, homeWorkWeight = props.homeWorkWeight, onWeightChange = props.onWeightChange, groupId = props.groupId, onGroupChange = props.onGroupChange;
    var groups = useSelector(function (store) { return getLMSGroups(store); }).groups;
    var content = type === 'text'
        ? 'Напишите эссе'
        : type === 'code'
            ? 'Напишите код'
            : t('editor.courses.placeholders.header');
    var SYSTEM_OPTIONS = [
        { label: t('editor.courses.assessment_system.pass_fail'), value: '0' },
        { label: t('editor.courses.assessment_system.point_scale'), value: '1' }
    ];
    var translatedGroups = useMemo(function () { return API.toLang(groups, language); }, [language, groups]);
    var GROUP_OPTIONS = useMemo(function () { return __spreadArray([], ((translatedGroups === null || translatedGroups === void 0 ? void 0 : translatedGroups.map(function (g) { return ({
        value: (g === null || g === void 0 ? void 0 : g.id) || '',
        label: (g === null || g === void 0 ? void 0 : g.name) || (g === null || g === void 0 ? void 0 : g.title) || ''
    }); })) || []), true); }, [translatedGroups, t]);
    var selectedGroup = useMemo(function () {
        if (!groupId)
            return [];
        var groupIds = [];
        if (typeof groupId === 'string') {
            try {
                var parsed = JSON.parse(groupId);
                groupIds = Array.isArray(parsed) ? parsed : [groupId];
            }
            catch (_a) {
                groupIds = groupId ? [groupId] : [];
            }
        }
        else if (Array.isArray(groupId)) {
            groupIds = groupId;
        }
        return GROUP_OPTIONS.filter(function (opt) {
            return opt.value && groupIds.includes(opt.value);
        });
    }, [GROUP_OPTIONS, groupId]);
    var handleWeightChange = function (e) {
        var value = e.target.value;
        if (value === '' || /^\d+$/.test(value)) {
            var numValue = parseInt(value, 10);
            if (value === '' || (numValue >= 0 && numValue <= 10)) {
                onWeightChange({ label: value, value: value });
            }
        }
    };
    var handleGroupChange = function (selectedOptions) {
        if (onGroupChange) {
            var options = selectedOptions || [];
            var optionsArray = Array.isArray(options) ? options : [options];
            var groupIds = optionsArray
                .filter(function (opt) { return opt && opt.value && opt.value !== ''; })
                .map(function (opt) { return opt.value; });
            var label = optionsArray
                .filter(function (opt) { return opt && opt.label; })
                .map(function (opt) { return opt.label; })
                .join(', ') || '';
            var value = groupIds.length === 0
                ? ''
                : groupIds.length === 1
                    ? groupIds[0]
                    : JSON.stringify(groupIds);
            onGroupChange({ label: label, value: value });
        }
    };
    return (React.createElement(FlexBox, { direction: "column" },
        React.createElement(CourseHomeworkEditWrapper, { direction: 'column', directionMobile: 'column', className: 'course-section' },
            React.createElement(CourseTitle, { offsetBottom: 8 }, t('editor.courses.title')),
            React.createElement(InputGroupWrapper, null,
                React.createElement(HeaderInput, { value: text, onChange: function (e) { return onHeaderChange(e.target.value); }, placeholder: content }))),
        React.createElement(FlexBox, { gx: 24 },
            React.createElement(CourseHomeworkEditWrapper, { width: '50%', direction: 'column', directionMobile: 'column', className: 'course-section' },
                React.createElement(CourseTitle, { offsetBottom: 8 }, t('editor.courses.assessment_system.title')),
                React.createElement(InputWrapper, null,
                    React.createElement(Input.Dropdown, { value: SYSTEM_OPTIONS[nominationType], onChange: onSystemType, options: SYSTEM_OPTIONS }))),
            React.createElement(CourseHomeworkEditWrapper, { width: '50%', direction: 'column', directionMobile: 'column', className: 'course-section' },
                React.createElement(CourseTitle, { offsetBottom: 8 }, t('editor.courses.weight')),
                React.createElement(InputGroupWrapper, null,
                    React.createElement(HeaderInput, { value: homeWorkWeight, onChange: handleWeightChange, placeholder: "0" })))),
        React.createElement(FlexBox, { gx: 24, offsetTop: 24 },
            React.createElement(CourseHomeworkEditWrapper, { width: '100%', direction: 'column', directionMobile: 'column', className: 'course-section' },
                React.createElement(CourseTitle, { offsetBottom: 8 }, t('lms.lesson_edit.group')),
                React.createElement(InputWrapper, null,
                    React.createElement(Input.Dropdown, { isMulti: true, value: selectedGroup, onChange: handleGroupChange, options: GROUP_OPTIONS, placeholder: t('lms.lesson_edit.choose_group') }))))));
};
var templateObject_1;
//# sourceMappingURL=HeaderBlock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FlexBox } from '@brg/ui';
import React, { useMemo } from 'react';
import { CourseHomeworkEditWrapper, CourseTitle, InputWrapper } from '../style';
import useLocalization from '../../../../../../hooks/useLocalization';
import { Input as StyledInput, InputGroupWrapper } from '../../../editor/MediaInputGroup/styles';
import { Input } from '@brg/input';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getLMSGroups } from '../../../../../../reducers/getLMSInfo';
import { API } from '@brg/api';
var HeaderInput = styled(StyledInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   font-size: 15px;\n   line-height: 20px;\n"], ["\n   font-size: 15px;\n   line-height: 20px;\n"])));
export var HeaderBlock = function (props) {
    var _a = useLocalization(), t = _a.t, language = _a.language;
    var text = props.text, onHeaderChange = props.onHeaderChange, type = props.type, nominationType = props.nominationType, onSystemType = props.onSystemType, homeWorkWeight = props.homeWorkWeight, onWeightChange = props.onWeightChange, groupId = props.groupId, onGroupChange = props.onGroupChange;
    var groups = useSelector(function (store) { return getLMSGroups(store); }).groups;
    var content = type === 'text'
        ? 'Напишите эссе'
        : type === 'code'
            ? 'Напишите код'
            : t('editor.courses.placeholders.header');
    var SYSTEM_OPTIONS = [
        { label: t('editor.courses.assessment_system.pass_fail'), value: '0' },
        { label: t('editor.courses.assessment_system.point_scale'), value: '1' }
    ];
    var translatedGroups = useMemo(function () { return API.toLang(groups, language); }, [language, groups]);
    var GROUP_OPTIONS = useMemo(function () { return __spreadArray([], ((translatedGroups === null || translatedGroups === void 0 ? void 0 : translatedGroups.map(function (g) { return ({
        value: (g === null || g === void 0 ? void 0 : g.id) || '',
        label: (g === null || g === void 0 ? void 0 : g.name) || (g === null || g === void 0 ? void 0 : g.title) || ''
    }); })) || []), true); }, [translatedGroups, t]);
    var selectedGroup = useMemo(function () {
        if (!groupId)
            return [];
        var groupIds = [];
        if (typeof groupId === 'string') {
            try {
                var parsed = JSON.parse(groupId);
                groupIds = Array.isArray(parsed) ? parsed : [groupId];
            }
            catch (_a) {
                groupIds = groupId ? [groupId] : [];
            }
        }
        else if (Array.isArray(groupId)) {
            groupIds = groupId;
        }
        return GROUP_OPTIONS.filter(function (opt) {
            return opt.value && groupIds.includes(opt.value);
        });
    }, [GROUP_OPTIONS, groupId]);
    var handleWeightChange = function (e) {
        var value = e.target.value;
        if (value === '' || /^\d+$/.test(value)) {
            var numValue = parseInt(value, 10);
            if (value === '' || (numValue >= 0 && numValue <= 10)) {
                onWeightChange({ label: value, value: value });
            }
        }
    };
    var handleGroupChange = function (selectedOptions) {
        if (onGroupChange) {
            var options = selectedOptions || [];
            var optionsArray = Array.isArray(options) ? options : [options];
            var groupIds = optionsArray
                .filter(function (opt) { return opt && opt.value && opt.value !== ''; })
                .map(function (opt) { return opt.value; });
            var label = optionsArray
                .filter(function (opt) { return opt && opt.label; })
                .map(function (opt) { return opt.label; })
                .join(', ') || '';
            var value = groupIds.length === 0
                ? ''
                : groupIds.length === 1
                    ? groupIds[0]
                    : JSON.stringify(groupIds);
            onGroupChange({ label: label, value: value });
        }
    };
    return (React.createElement(FlexBox, { direction: "column" },
        React.createElement(CourseHomeworkEditWrapper, { direction: 'column', directionMobile: 'column', className: 'course-section' },
            React.createElement(CourseTitle, { offsetBottom: 8 }, t('editor.courses.title')),
            React.createElement(InputGroupWrapper, null,
                React.createElement(HeaderInput, { value: text, onChange: function (e) { return onHeaderChange(e.target.value); }, placeholder: content }))),
        React.createElement(FlexBox, { gx: 24 },
            React.createElement(CourseHomeworkEditWrapper, { width: '50%', direction: 'column', directionMobile: 'column', className: 'course-section' },
                React.createElement(CourseTitle, { offsetBottom: 8 }, t('editor.courses.assessment_system.title')),
                React.createElement(InputWrapper, null,
                    React.createElement(Input.Dropdown, { value: SYSTEM_OPTIONS[nominationType], onChange: onSystemType, options: SYSTEM_OPTIONS }))),
            React.createElement(CourseHomeworkEditWrapper, { width: '50%', direction: 'column', directionMobile: 'column', className: 'course-section' },
                React.createElement(CourseTitle, { offsetBottom: 8 }, t('editor.courses.weight')),
                React.createElement(InputGroupWrapper, null,
                    React.createElement(HeaderInput, { value: homeWorkWeight, onChange: handleWeightChange, placeholder: "0" })))),
        React.createElement(FlexBox, { gx: 24, offsetTop: 24 },
            React.createElement(CourseHomeworkEditWrapper, { width: '100%', direction: 'column', directionMobile: 'column', className: 'course-section' },
                React.createElement(CourseTitle, { offsetBottom: 8 }, t('lms.lesson_edit.group')),
                React.createElement(InputWrapper, null,
                    React.createElement(Input.Dropdown, { isMulti: true, value: selectedGroup, onChange: handleGroupChange, options: GROUP_OPTIONS, placeholder: t('lms.lesson_edit.choose_group') }))))));
};
var templateObject_1;
//# sourceMappingURL=HeaderBlock.js.map